import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class GlobalUIUtilsService {

  constructor(private toastr: ToastrService,  private translate: TranslateService) { }

  public show() : void {
    document.getElementById('loadingSpinner').style.display = 'block';
  }

  public hide() : void {
    document.getElementById('loadingSpinner').style.display = 'none';
  }

    success(message: string, title?: string) {
    this.toastr.success(message);
  }



}
